import React, { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { FormattedMessage } from '@techstyle/react-intl';

import { deleteMembershipFromCart } from '../../actions/checkout';
import { MembershipActionLocation } from '../../constants/checkout';

import { useToastMessage } from './useToastMessage';

export function useRemoveMembershipFromCartDrawer() {
  const dispatch = useDispatch();
  const { showToastMessage } = useToastMessage();
  const removeMembershipFromCartDrawer = useCallback(() => {
    dispatch(
      deleteMembershipFromCart({
        location: MembershipActionLocation.MINI_CART,
        productId: null,
      })
    );

    showToastMessage(
      // @ts-ignore
      <FormattedMessage
        id="global_checkout.vip_item_removed_message"
        defaultMessage="Savage X Rewards Membership Savings Removed"
      />
    );
  }, [dispatch, showToastMessage]);
  return removeMembershipFromCartDrawer;
}
